import React, { PureComponent } from 'react'
import upload from './config'
import Upload from '../Upload'
import ClipModal from '../ClipModal'
export default class extends PureComponent {
  constructor(props) {
    super(props)

    this.uploader = null
    this.fileId = ''
    this.file = null
    this.browseBtn = 'browseBtn_' + Math.random().toFixed(8)
    this.container = 'container_' + Math.random().toFixed(8)

    this.state = {
      progress: false,
      percent: 0,
      isMouseEnter: false,
      previewModal: false
    }
  }

  static defaultProps = {
    multiple: false,
    link: '',
    uptoken_url: 'image_upload_token'
  }

  toggleProgress = show => {
    this.setState({
      percent: 0,
      progress: show
    })

    this.uploader.disableBrowse(show)
  }

  cancelUpload = () => {
    if (this.fileId) {
      this.uploader.removeFile(this.fileId)
    }
    this.toggleProgress(false)
  }

  // todo, to be removed
  hover = type => e => {
    if (type === 'over') {
      this.setState({ isMouseEnter: true })
    } else if (type === 'out') {
      this.setState({ isMouseEnter: false })
    }
  }

  preview = () => {
    if (this.props.onPreview) {
      this.props.onPreview(this.props.link)
    } else {
      this.setState({
        previewModal: !this.state.previewModal
      })
    }
  }

  componentDidMount() {
    const {
      onOk,
      onAdded,
      multiple,
      onBeforeUp,
      onError,
      uptoken_url,
      ...rest
    } = this.props

    this.uploader = upload({
      uptoken_url: '/p/wedding/home/APIUtils/' + uptoken_url,
      browse_button: this.browseBtn,
      container: this.container,
      multi_selection: multiple,
      drop_element: this.browseBtn,
      filesAdded: (up, files) => {
        onAdded && onAdded(files, up, this.toggleProgress)
      },
      //上传前
      beforeUpload: (up, file) => {
        this.file = null
        this.fileId = file.id
        this.toggleProgress(true)
        onBeforeUp && onBeforeUp(file, up, this.toggleProgress)
      },
      //上传中
      uploadProgress: (file, percent) => {
        this.setState({
          percent
        })

        this.uploader.disableBrowse(true)
      },
      //上传后
      fileUploaded: (file, link, info, up) => {
        this.file = file
        this.toggleProgress(false)
        onOk && onOk(file, link, info, up)
        if (this.props.clipabled) {
          this.preview()
        }
      },
      //上传失败
      onError: (up, err, errTip) => {
        this.fileId && up.removeFile(this.fileId)
        this.toggleProgress(false)
        onError && onError(up, err, errTip)
      },
      ...rest
    })
  }

  render() {
    let { previewModal } = this.state
    const {
      children,
      onCliped,
      clipabled,
      aspect,
      link,
      clipConfig
    } = this.props

    return typeof children === 'function' ? (
      <div
        onMouseEnter={this.hover('over')}
        onMouseLeave={this.hover('out')}
        id={this.container}
        style={{ display: 'inline-block' }}
      >
        {children({
          ...this.props,
          ...this.state,
          cancel: this.cancelUpload,
          provided: {
            id: this.browseBtn
          }
        })}
        {previewModal &&
          clipabled && (
            <ClipModal
              aspect={aspect}
              clipConfig={clipConfig}
              onCliped={onCliped}
              visible={previewModal}
              img={link}
              onCancel={this.preview}
            />
          )}
      </div>
    ) : (
      <Upload {...this.props} />
    )
  }
}
